import React, { useState } from 'react';
import { bool, func, object, shape, string, oneOf } from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from '../../util/reactIntl';
import { connect } from 'react-redux';
import { types as sdkTypes } from '../../util/sdkLoader';
import { withViewport } from '../../util/contextHelpers';
import {
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_NEW,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  LISTING_PAGE_PARAM_TYPES,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  createSlug,
} from '../../util/urlHelpers';
import { LISTING_TYPES } from 'util/constants';
import { LISTING_STATE_DRAFT, LISTING_STATE_PENDING_APPROVAL, propTypes } from '../../util/types';
import { ensureOwnListing } from '../../util/data';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';
import { logout } from '../../ducks/Auth.duck';
import {
  stripeAccountClearError,
  createStripeAccount,
  getStripeConnectAccountLink,
} from '../../ducks/stripeConnectAccount.duck';
import { EditListingWizard, Footer, NamedRedirect, Page } from '../../components';
import EditEnquiryPage from './EditEnquiryPage/EditEnquiryPage';
import { TopbarContainer, HeaderContainer } from '../../containers';
import { createResourceLocatorString } from 'util/routes';
import routeConfiguration from '../../routeConfiguration';
import {
  requestAddAvailabilityException,
  requestDeleteAvailabilityException,
  requestCreateListingDraft,
  requestPublishListingDraft,
  requestUpdateListing,
  requestImageUpload,
  updateImageOrder,
  removeListingImage,
  loadData,
  clearUpdatedTab,
  savePayoutDetails,
} from './EditListingPage.duck';
import { CurrentUserContext } from 'contexts/currentUserContext';
import { queryPromotedListings } from '../HomePage/HomePage.duck';

import css from './EditListingPage.css';

const MAX_MOBILE_SCREEN_WIDTH = 1024;

const STRIPE_ONBOARDING_RETURN_URL_SUCCESS = 'success';
const STRIPE_ONBOARDING_RETURN_URL_FAILURE = 'failure';
const STRIPE_ONBOARDING_RETURN_URL_TYPES = [
  STRIPE_ONBOARDING_RETURN_URL_SUCCESS,
  STRIPE_ONBOARDING_RETURN_URL_FAILURE,
];

const { UUID } = sdkTypes;

const getEditPageName = listingType => {
  switch (listingType) {
    case LISTING_TYPES.COMPANY:
      return 'EditCompanyPage';
    case LISTING_TYPES.FREELANCER:
      return 'EditFreelancerPage';
    case LISTING_TYPES.FACILITY:
      return 'EditFacilityPage';
    case LISTING_TYPES.ENQUIRY:
      return 'EditInquirePage';
    case LISTING_TYPES.CLASS:
      return 'EditClassPage';
    case LISTING_TYPES.EVENT:
      return 'EditEventPage';
    case LISTING_TYPES.PRODUCT:
      return 'EditProductPage';
    case LISTING_TYPES.MEMBERSHIP:
      return 'EditMembershipPage';
    case LISTING_TYPES.PLAYER_PROFILE:
      return 'EditPlayerProfilePage';
    case LISTING_TYPES.LISTING:
    default:
      return 'EditListingPage';
  }
};

// N.B. All the presentational content needs to be extracted to their own components
export const EditListingPageComponent = props => {
  const {
    currentUser,
    currentUserListing,
    currentUserListingFetched,
    createStripeAccountError,
    fetchInProgress,
    getOwnListing,
    history,
    intl,
    onAddAvailabilityException,
    onDeleteAvailabilityException,
    onCreateListingDraft,
    onPublishListingDraft,
    onUpdateListing,
    onImageUpload,
    onRemoveListingImage,
    onManageDisableScrolling,
    onPayoutDetailsFormSubmit,
    onPayoutDetailsFormChange,
    onGetStripeConnectAccountLink,
    onUpdateImageOrder,
    onChange,
    page,
    params,
    scrollingDisabled,
    allowOnlyOneListing,
    stripeAccountFetched,
    stripeAccount,
    canCreateListing,
    canCreateListingRequestInProgress,
    viewport,
    onQueryPromotedListings,
    enquiryListings,
    searchActivity,
    isAuthenticated,
    logoutInProgress,
  } = props;

  const { id, type, returnURLType } = params;
  const isNewURI = type === LISTING_PAGE_PARAM_TYPE_NEW;
  const isDraftURI = type === LISTING_PAGE_PARAM_TYPE_DRAFT;
  const isNewListingFlow = isNewURI || isDraftURI;
  const listingType = props.listingType ? props.listingType : LISTING_TYPES.LISTING;
  const isEducationSite = props.isEducationSite || listingType === LISTING_TYPES.ENQUIRY;

  const listingId = page.submittedListingId || (id ? new UUID(id) : null);
  const listing = getOwnListing(listingId);
  const currentListing = ensureOwnListing(listing);
  const { state: currentListingState } = currentListing.attributes;

  const isPastDraft = currentListingState && currentListingState !== LISTING_STATE_DRAFT;
  // const shouldRedirect =
  //   (isNewListingFlow && listingId && isPastDraft) ||
  //   (!canCreateListingRequestInProgress && !canCreateListing);

  const shouldRedirect = isNewListingFlow && listingId && isPastDraft;

  const hasStripeOnboardingDataIfNeeded = returnURLType ? !!(currentUser && currentUser.id) : true;
  const showForm =
    !canCreateListingRequestInProgress &&
    hasStripeOnboardingDataIfNeeded &&
    (isNewURI || currentListing.id);

  const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;

  const [currentTab, setCurrentTab] = useState(true);
  const [openLeftBar, setOpenLeftBar] = useState(false);
  const [isOpenSearchBar, setIsOpenSearchBar] = useState(false);
  const [showOpacity, setShowOpacity] = useState('');
  const [selectedSubCategory, setSelectedSubCategory] = useState(searchActivity);
  const [quryParams, setQuryParams] = useState(null);
  const [isScrolling, setIsScrolling] = useState(false);

  // useEffect(() => {
  //   if (typeof window !== 'undefined') {
  //     window.onscroll = () => {
  //       let currentScrollPos = window.pageYOffset;
  //       let maxScroll = document.body.scrollHeight - (window.innerHeight - 50);
  //       if (currentScrollPos > 0 && currentScrollPos < maxScroll) {
  //         setIsScrolling(true);
  //       } else {
  //         setIsScrolling(false);
  //       }
  //     };
  //   }
  // }, []);

  // const listingType =
  //   isNewListingFlow && props.listingType ? props.listingType : LISTING_TYPES.LISTING;

  const onSearch = searchquery => {
    history.push(
      createResourceLocatorString(
        isEducationSite ? 'EducationPage' : 'HomePage',
        routeConfiguration(),
        {}
      )
    );
    setQuryParams(searchquery);
    setTimeout(() => {
      onQueryPromotedListings(searchquery);
    }, 500);
  };

  const onTabChangeSearch = searchquery => {
    setQuryParams(searchquery);
    props.onqueryPromotedListings(searchquery);
  };

  const handleHeaderSearchBar = value => {
    setIsOpenSearchBar(value);
  };

  const handleOpacityChange = value => {
    setShowOpacity(value);
  };

  if (shouldRedirect) {
    const isPendingApproval =
      currentListing && currentListingState === LISTING_STATE_PENDING_APPROVAL;

    // If page has already listingId (after submit) and current listings exist
    // redirect to listing page
    const listingSlug =
      canCreateListing && currentListing ? createSlug(currentListing.attributes.title) : null;
    const redirectProps = !canCreateListing
      ? {
          name: 'SubscriptionPage',
        }
      : isPendingApproval
      ? {
          name: 'ListingPageVariant',
          params: {
            id: listingId.uuid,
            slug: listingSlug,
            variant: LISTING_PAGE_PENDING_APPROVAL_VARIANT,
          },
        }
      : {
          name: 'ListingPage',
          params: {
            id: listingId.uuid,
            slug: listingSlug,
          },
        };
    return <NamedRedirect {...redirectProps} />;
  } else if (allowOnlyOneListing && isNewURI && currentUserListingFetched && currentUserListing) {
    // If we allow only one listing per provider, we need to redirect to correct listing.
    return (
      <NamedRedirect
        name={getEditPageName(listingType)}
        params={{
          id: currentUserListing.id.uuid,
          slug: createSlug(currentUserListing.attributes.title),
          type: LISTING_PAGE_PARAM_TYPE_EDIT,
          tab: 'description',
        }}
      />
    );
  } else if (showForm) {
    const {
      createListingDraftError = null,
      publishListingError = null,
      updateListingError = null,
      showListingsError = null,
      uploadImageError = null,
      fetchExceptionsError = null,
      addExceptionError = null,
      deleteExceptionError = null,
    } = page;
    const errors = {
      createListingDraftError,
      publishListingError,
      updateListingError,
      showListingsError,
      uploadImageError,
      createStripeAccountError,
      fetchExceptionsError,
      addExceptionError,
      deleteExceptionError,
    };
    // TODO: is this dead code? (shouldRedirect is checked before)
    const newListingPublished =
      isDraftURI && currentListing && currentListingState !== LISTING_STATE_DRAFT;

    // Show form if user is posting a new listing or editing existing one
    const disableForm = page.redirectToListing && !showListingsError;

    // Images are passed to EditListingForm so that it can generate thumbnails out of them
    const currentListingImages =
      currentListing && currentListing.images ? currentListing.images : [];

    // Images not yet connected to the listing
    const imageOrder = page.imageOrder || [];
    const unattachedImages = imageOrder.map(i => page.images[i]);

    const allImages = currentListingImages.concat(unattachedImages);
    const removedImageIds = page.removedImageIds || [];
    const images = allImages.filter(img => {
      return !removedImageIds.includes(img.id);
    });

    const title = isNewListingFlow
      ? intl.formatMessage({
          id: 'EditListingPage.titleCreateListing',
        })
      : intl.formatMessage({
          id: 'EditListingPage.titleEditListing',
        });
    return (
      <Page title={title} scrollingDisabled={scrollingDisabled}>
        <HeaderContainer
          onSearch={onSearch}
          onTabChangeSearch={onTabChangeSearch}
          handleHeaderSearchBar={handleHeaderSearchBar}
          handleOpacityChange={handleOpacityChange}
          openLeftBar={() => setOpenLeftBar(true)}
          isMobileLayout={isMobileLayout}
          currentTab={tab => setCurrentTab(tab)}
          showOpacity={showOpacity}
          hideBottomHeader={true}
          showBottomHeaderListingPage={false}
          viewport={viewport}
          onChangeActivity={value => setSelectedSubCategory(value)}
          onQueryPromotedListings={onQueryPromotedListings}
          isScrolling={isScrolling}
          hideBackgroundImage={true}
          isAuthenticated={isAuthenticated}
          logoutInProgress={logoutInProgress}
          logout={props.onLogout}
          currentUser={currentUser}
          isEducationSite={isEducationSite}
        />
        {isNewListingFlow && props.listingType === LISTING_TYPES.ENQUIRY ? (
          <EditEnquiryPage
            currentUser={currentUser}
            onCreateListingDraft={onCreateListingDraft}
            onPublishListingDraft={onPublishListingDraft}
            currentListing={currentListing}
            listingType={props.listingType}
            onQueryPromotedListings={onQueryPromotedListings}
            enquiryListings={enquiryListings}
            intl={intl}
            history={history}
            isEducationSite={isEducationSite}
          />
        ) : (
          <>
            <CurrentUserContext.Provider value={currentUser}>
              <EditListingWizard
                id="EditListingWizard"
                type={listingType}
                className={css.wizard}
                params={params}
                disabled={disableForm}
                errors={errors}
                fetchInProgress={fetchInProgress}
                newListingPublished={newListingPublished}
                history={history}
                images={images}
                listing={currentListing}
                onAddAvailabilityException={onAddAvailabilityException}
                onDeleteAvailabilityException={onDeleteAvailabilityException}
                onUpdateListing={onUpdateListing}
                onCreateListingDraft={onCreateListingDraft}
                onPublishListingDraft={onPublishListingDraft}
                onPayoutDetailsFormChange={onPayoutDetailsFormChange}
                onPayoutDetailsSubmit={onPayoutDetailsFormSubmit}
                onGetStripeConnectAccountLink={onGetStripeConnectAccountLink}
                onImageUpload={onImageUpload}
                onUpdateImageOrder={onUpdateImageOrder}
                onRemoveImage={onRemoveListingImage}
                onChange={onChange}
                currentUser={currentUser}
                onManageDisableScrolling={onManageDisableScrolling}
                stripeOnboardingReturnURL={params.returnURLType}
                updatedTab={page.updatedTab}
                updateInProgress={page.updateInProgress || page.createListingDraftInProgress}
                fetchExceptionsInProgress={page.fetchExceptionsInProgress}
                availabilityExceptions={page.availabilityExceptions}
                payoutDetailsSaveInProgress={page.payoutDetailsSaveInProgress}
                payoutDetailsSaved={page.payoutDetailsSaved}
                stripeAccountFetched={stripeAccountFetched}
                stripeAccount={stripeAccount}
                isEducationSite={isEducationSite}
              />
            </CurrentUserContext.Provider>
            <Footer isEducationSite={isEducationSite} />
          </>
        )}
      </Page>
    );
  } else {
    // If user has come to this page through a direct linkto edit existing listing,
    // we need to load it first.
    const loadingPageMsg = {
      id: 'EditListingPage.loadingListingData',
    };
    return (
      <Page title={intl.formatMessage(loadingPageMsg)} scrollingDisabled={scrollingDisabled}>
        <TopbarContainer
          className={css.topbar}
          mobileRootClassName={css.mobileTopbar}
          desktopClassName={css.desktopTopbar}
          mobileClassName={css.mobileTopbar}
          isEducationSite={isEducationSite}
        />
        <div className={css.placeholderWhileLoading}>loading ...</div>
        <Footer isEducationSite={isEducationSite} />
      </Page>
    );
  }
};

EditListingPageComponent.defaultProps = {
  createStripeAccountError: null,
  currentUser: null,
  currentUserHasOrders: null,
  listing: null,
  listingDraft: null,
  notificationCount: 0,
  sendVerificationEmailError: null,
  currentUserListing: null,
  currentUserListingFetched: false,
  listingType: LISTING_TYPES.LISTING,
};

EditListingPageComponent.propTypes = {
  createStripeAccountError: propTypes.error,
  currentUser: propTypes.currentUser,
  getOwnListing: func.isRequired,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,
  onAddAvailabilityException: func.isRequired,
  onDeleteAvailabilityException: func.isRequired,
  onCreateListingDraft: func.isRequired,
  onPublishListingDraft: func.isRequired,
  onImageUpload: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  onPayoutDetailsFormChange: func.isRequired,
  onPayoutDetailsSubmit: func.isRequired,
  onUpdateImageOrder: func.isRequired,
  onRemoveListingImage: func.isRequired,
  onUpdateListing: func.isRequired,
  onChange: func.isRequired,
  page: object.isRequired,
  params: shape({
    id: string.isRequired,
    slug: string.isRequired,
    type: oneOf(LISTING_PAGE_PARAM_TYPES).isRequired,
    tab: string.isRequired,
    returnURLType: oneOf(STRIPE_ONBOARDING_RETURN_URL_TYPES),
  }).isRequired,
  scrollingDisabled: bool.isRequired,
  listingType: string,

  /* from withRouter */
  history: shape({
    push: func.isRequired,
  }).isRequired,

  /* from injectIntl */
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const page = state.EditListingPage;

  const {
    getAccountLinkInProgress,
    createStripeAccountInProgress,
    createStripeAccountError,
    updateStripeAccountError,
    fetchStripeAccountError,
    stripeAccount,
    stripeAccountFetched,
  } = state.stripeConnectAccount;

  const {
    currentUser,
    currentUserListing,
    currentUserListingFetched,
    currentUserHasCompanyOrFreelancer,
  } = state.user;

  const { isAuthenticated, logoutInProgress } = state.Auth;

  const { promotedListingRefs } = state.HomePage;
  const { searchActivity } = state.HeaderSection;
  const {
    canCreateListing,
    createListingNotAllowedMessage,
    canCreateListingRequestInProgress,
  } = page;

  const fetchInProgress = createStripeAccountInProgress;
  const enquiryListings = getMarketplaceEntities(state, promotedListingRefs);
  const getOwnListing = id => {
    const listings = getMarketplaceEntities(state, [{ id, type: 'ownListing' }]);

    return listings.length === 1 ? listings[0] : null;
  };
  return {
    getAccountLinkInProgress,
    createStripeAccountError,
    updateStripeAccountError,
    fetchStripeAccountError,
    stripeAccount,
    stripeAccountFetched,
    currentUser,
    currentUserListing,
    currentUserListingFetched,
    currentUserHasCompanyOrFreelancer,
    fetchInProgress,
    getOwnListing,
    page,
    canCreateListing,
    createListingNotAllowedMessage,
    canCreateListingRequestInProgress,
    scrollingDisabled: isScrollingDisabled(state),
    enquiryListings,
    searchActivity,
    isAuthenticated,
    logoutInProgress,
  };
};

const mapDispatchToProps = dispatch => ({
  onAddAvailabilityException: params => dispatch(requestAddAvailabilityException(params)),
  onDeleteAvailabilityException: params => dispatch(requestDeleteAvailabilityException(params)),
  onUpdateListing: (tab, values) => dispatch(requestUpdateListing(tab, values)),
  onCreateListingDraft: values => dispatch(requestCreateListingDraft(values)),
  onPublishListingDraft: listingId => dispatch(requestPublishListingDraft(listingId)),
  onImageUpload: data => dispatch(requestImageUpload(data)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onPayoutDetailsFormChange: () => dispatch(stripeAccountClearError()),
  onPayoutDetailsSubmit: values => dispatch(createStripeAccount(values)),
  onPayoutDetailsFormSubmit: (values, isUpdateCall) =>
    dispatch(savePayoutDetails(values, isUpdateCall)),
  onGetStripeConnectAccountLink: params => dispatch(getStripeConnectAccountLink(params)),
  onUpdateImageOrder: imageOrder => dispatch(updateImageOrder(imageOrder)),
  onRemoveListingImage: imageId => dispatch(removeListingImage(imageId)),
  onChange: () => dispatch(clearUpdatedTab()),
  onQueryPromotedListings: searchquery => dispatch(queryPromotedListings(searchquery)),
  onLogout: historyPush => dispatch(logout(historyPush)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const EditListingPage = compose(
  withRouter,
  withViewport,
  connect(mapStateToProps, mapDispatchToProps)
)(injectIntl(EditListingPageComponent));

EditListingPage.loadData = loadData;

export default EditListingPage;
